module.exports = __webpack_public_path__ + "img/f8ee53e.png";